import {Pipe, PipeTransform} from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {permissions} from '../../../../libs/constants/permissions';

@Pipe({
  name: 'permission',
  standalone: false,
})
export class PermissionPipe implements PipeTransform {
  private readonly profileStore =
    localStorage.getItem('profile') || sessionStorage.getItem('profile');
  private readonly profile = JSON.parse(this.profileStore || '{}');

  transform(value: string): boolean {
    if (!value || !this.profile?.role) {
      return false;
    }

    // Split the permission string (e.g., "withdrawal.write")
    const parts = value.split('.');
    if (parts.length !== 2) {
      return false;
    }

    const [resource, action] = parts;
    const userRole = this.profile.role;

    try {
      // Check if the resource exists in permissions
      const resourcePermissions =
        permissions[resource as keyof typeof permissions];
      if (!resourcePermissions) {
        return false;
      }

      // Check if the user's role has the required action
      const rolePermissions =
        resourcePermissions[userRole as keyof typeof resourcePermissions];
      if (!Array.isArray(rolePermissions)) {
        return false;
      }

      // Return true if the action is in the role's permissions
      return rolePermissions.includes(action);
    } catch (error) {
      console.warn('Permission check failed:', error);
      return false;
    }
  }
}
